module.exports = __webpack_public_path__ + "img/check_box_outline_blank.e3722ad6.svg";